import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserLoginData } from '../landing-shared/login-by-sms/login-by-sms-form/login-by-sms-form.component';

@Component({
  selector: 'tax-login-by-sms',
  templateUrl: 'login-by-sms.component.html',
  styleUrls: ['login-by-sms.component.sass'],
})

export class LoginBySmsComponent {
  isFormPage = true;
  userInfo?: UserLoginData;

  constructor(
    private router: Router,
  ) {}

  login(): void {
    this.router.navigate(['main/kkms']);
  }

  setUserInfo(userInfo: UserLoginData): void {
    this.userInfo = userInfo;
    this.isFormPage = false;
  }
}
